import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { ConfirmModal } from '../models/confirm-modal';

export const useConfirm = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [resolvePromise, setResolvePromise] = useState<(value: boolean) => void | null>();

  const confirm = (msg: string): Promise<boolean> => {
    setMessage(msg); // Update the message state with the provided message
    setIsVisible(true);
    return new Promise<boolean>((resolve) => {
      setResolvePromise(() => resolve);
    });
  };

  const handleConfirm = () => {
    if (resolvePromise) resolvePromise(true);
    setIsVisible(false);
  };

  const handleCancel = () => {
    if (resolvePromise) resolvePromise(false);
    setIsVisible(false);
  };

  const modal = isVisible
    ? ReactDOM.createPortal(
        <ConfirmModal
          message={message} // Pass the updated message state to the ConfirmModal
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />,
        document.body
      )
    : null;

  return { confirm, modal };
};
